import { getUrlParam, useTranslation, Toast, copyText } from '@common';
import { getLinkDataInfoValue } from '@src/utils';
import React from 'react';
import IMOJI from '@src/assest/emoji.png';
import './index.less';

export const Main = () => {
  const { t } = useTranslation();

  const handleClick = () => {
    copyText(roomCode, () => {
      Toast.show(String(t('copy_succees')));
    });
  };

  return (
    <div className="home">
      <div className="content">
        <img src={IMOJI} alt="emoji" className="emoji" />
        {roomCode ? (
          <>
            <div className="text">{t('jump_text_1')}</div>
            <div className="room-code" onClick={handleClick}>{`Room ID: ${roomCode}`}</div>
            <div className="split">
              <div className="line"></div>
              <div className="or">{t('or')}</div>
              <div className="line"></div>
            </div>
          </>
        ) : null}
        <div className="text">{t('jump_text_2')}</div>
        <div className="download" onClick={jump}>
          {t('download_text')}
        </div>
      </div>
    </div>
  );
};

const jump = () => {
  window.location.href = 'https://www.honorofkings.com';
};
const roomCode = getUrlParam('roomCode') || getLinkDataInfoValue('roomCode') || '';
